"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var changeCase_1 = require("./changeCase");

var typeChecks_1 = require("./typeChecks");

var ConditionalHelper_1 = require("../helpers/ConditionalHelper");

var isArrayLike_1 = require("./isArrayLike");

function getCss(componentStyle, props, existingStyles, ignorePropsComponentStyle) {
  if (ignorePropsComponentStyle === void 0) {
    ignorePropsComponentStyle = false;
  }

  var response = existingStyles || [];

  if (componentStyle) {
    var breakpoints = componentStyle.breakpoints,
        selectors = componentStyle.selectors,
        conditionals = componentStyle.conditionals;
    var exclusionKeys_1 = ['_raw', 'breakpoints', 'selectors', 'conditionals', '_parameters', 'sizes', 'priorities', 'children', 'show', 'overrides', 'arrowDirection', 'chartProps', 'seriesColors', 'selected', 'groupHeader', 'groupChild']; // Loop over the available keys in the theme element object and add the styles for those to the response

    Object.entries(componentStyle).map(function (_a) {
      var key = _a[0],
          value = _a[1];

      if (exclusionKeys_1.indexOf(key) === -1) {
        addStyleForObjectOrString(response, value, changeCase_1.paramCase(key));
      }
    });
    addStylesForConditionals(response, conditionals, props); // Break points happen at the end for any overrides

    addStyleForBreakpoints(response, breakpoints, props); // ISelectors (hover etc)

    addStyleForSelectors(response, selectors, props); // Overrides for child components

    addStyleOverrides(response, componentStyle, props);

    if (componentStyle._raw && !typeChecks_1.isNullOrEmpty(componentStyle._raw)) {
      response.push(componentStyle._raw);
    }
  }

  if (!ignorePropsComponentStyle && props && props.componentStyle) {
    getCss(props.componentStyle, props, response, true);
  }

  return getCleanStyle(response);
}

exports.getCss = getCss;

function getCleanStyle(collection) {
  return collection.filter(function (value) {
    return !typeChecks_1.isNullOrEmpty(value);
  }).join('\n');
}

exports.getCleanStyle = getCleanStyle;

function addStyleForBreakpoints(collection, breakpoints, props) {
  if (breakpoints) {
    for (var _i = 0, breakpoints_1 = breakpoints; _i < breakpoints_1.length; _i++) {
      var breakpoint = breakpoints_1[_i];
      collection.push.apply(collection, getStyleForBreakpoint(breakpoint, props));
    }
  }
}

exports.addStyleForBreakpoints = addStyleForBreakpoints;

function getStyleForBreakpoint(breakpoint, props) {
  var response = [];
  var key = !typeChecks_1.isNullOrUndefined(breakpoint.max) ? 'max' : !typeChecks_1.isNullOrUndefined(breakpoint.min) ? 'min' : null;

  if (key) {
    var value = breakpoint[key];
    var defaultMedia = ['print', 'screen'];
    var media = breakpoint.media || defaultMedia;
    response.push("@media " + media.join(', ') + " and (" + key + "-width: " + value + ") {");
    getCss(breakpoint.style, props, response);
    response.push("}");
  }

  return response;
}

exports.getStyleForBreakpoint = getStyleForBreakpoint;

function addStyleForSelectors(collection, selectors, props) {
  var selectorsArray = [];

  if (!typeChecks_1.isNullOrUndefined(selectors)) {
    if (Array.isArray(selectors)) {
      selectorsArray.push.apply(selectorsArray, selectors);
    } else {
      selectorsArray.push(selectors);
    }
  }

  for (var _i = 0, selectorsArray_1 = selectorsArray; _i < selectorsArray_1.length; _i++) {
    var selector = selectorsArray_1[_i];
    Object.entries(selector).map(function (_a) {
      var key = _a[0],
          value = _a[1];
      var workingKey = key;

      if (value['_parameters'] && Array.isArray(value['_parameters'])) {
        workingKey += "(" + value['_parameters'].join(',') + ")";
      }

      collection.push("&" + workingKey + " {");
      getCss(value, props, collection);
      collection.push("}");
    });
  }
}

exports.addStyleForSelectors = addStyleForSelectors;

function addStylesForConditionals(collection, conditionalStyles, props) {
  var conditionalCss = (conditionalStyles || []).reduce(function (acc, conditionalStyle) {
    if (conditionalStyle) {
      var conditional = conditionalStyle.conditional,
          style = conditionalStyle.style;
      var conditionalHelper = new ConditionalHelper_1.ConditionalHelper(conditional);

      if (conditionalHelper.matches(props)) {
        acc.push(getCss(style, props));
      }
    }

    return acc;
  }, []);
  return collection.push.apply(collection, conditionalCss);
}

function addStyleOverrides(collection, componentStyle, props) {
  if (componentStyle && componentStyle.overrides) {
    for (var _i = 0, _a = componentStyle.overrides; _i < _a.length; _i++) {
      var override = _a[_i];
      var selector = override.selector,
          style = override.style;
      var childSelector = ['&', selector].join(' ');
      collection.push(childSelector + " {");
      getCss(style, props, collection, true);
      collection.push("}");
    }
  }
}

exports.addStyleOverrides = addStyleOverrides;

function getStyleForObject(styleObject, prefix) {
  var response = [];

  if (!typeChecks_1.isNullOrUndefined(styleObject)) {
    var workingPrefix_1 = prefix && prefix.toLowerCase() === prefix ? prefix : changeCase_1.paramCase(prefix);

    if (!typeChecks_1.isNullOrUndefined(styleObject['_value'])) {
      response.push(workingPrefix_1 + ": " + styleObject['_value'] + ";");
    }

    Object.entries(styleObject).map(function (_a) {
      var key = _a[0],
          value = _a[1];

      if (!key.startsWith('_') && !typeChecks_1.isNullOrUndefined(value) && value !== '') {
        if (typeChecks_1.isObject(value)) {
          response.push.apply(response, getStyleForObject(value, workingPrefix_1 + "-" + changeCase_1.paramCase(key)));
        } else {
          response.push(workingPrefix_1 + "-" + changeCase_1.paramCase(key) + ": " + value + ";");
        }
      }
    });
  }

  return response;
}

exports.getStyleForObject = getStyleForObject;

function addStyleForObjectOrString(collection, styleObject, prefix) {
  var workingPrefix = changeCase_1.paramCase(prefix);
  var response = [];

  if (!typeChecks_1.isNullOrUndefined(styleObject)) {
    if (typeChecks_1.isObject(styleObject)) {
      response.push.apply(response, getStyleForObject(styleObject, workingPrefix));
    } else {
      response.push(workingPrefix + ": " + styleObject + ";");
    }

    collection.push.apply(collection, response);
  }

  return '';
}

exports.addStyleForObjectOrString = addStyleForObjectOrString;

function orchestrateFontFace(fontFace) {
  if (fontFace && fontFace.fontFamily && fontFace.src && fontFace.src.length > 0) {
    return Object.keys(fontFace).sort().reduce(function (acc, key) {
      acc[key] = fontFace[key];
      return acc;
    }, {});
  }

  return undefined;
}

function getFontFaceId(fontFace) {
  return JSON.stringify(fontFace);
}

function joinPaths() {
  var paths = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    paths[_i] = arguments[_i];
  }

  return paths.filter(function (path) {
    return typeof path === 'string' && path.length > 0;
  }).map(function (path) {
    var response = path;

    while (response.startsWith('/')) {
      response = response.substr(1);
    }

    while (response.endsWith('/')) {
      response = response.substr(0, response.length - 1);
    }

    return response;
  }).join('/');
}

function getFontFaceCss(fontFace, baseUrl, fontFaceStore) {
  var response = undefined;
  fontFace = orchestrateFontFace(fontFace);

  if (fontFace && fontFace.fontFamily && fontFace.src) {
    var keys = Object.keys(fontFace);
    var fontFaceId = getFontFaceId(fontFace);

    if (!fontFaceStore || !fontFaceStore[fontFaceId]) {
      response = "@font-face {\n\t" + keys.map(function (key) {
        var value = fontFace[key];

        if (key === 'fontFamily') {
          value = "\"" + fontFace[key] + "\"";
        }

        if (key === 'src') {
          var src = fontFace[key];
          value = '';

          if (isArrayLike_1.isArrayLike(src)) {
            value = src.map(function (srcItem) {
              var url = srcItem.url,
                  format = srcItem.format;
              var workingUrl = url;

              if (!['https://', 'http://'].some(function (prefix) {
                return workingUrl && workingUrl.startsWith(prefix);
              })) {
                workingUrl = joinPaths(baseUrl, workingUrl);
              }

              var srcStr = "url(\"" + workingUrl + "\")";

              if (format && format.length > 0) {
                srcStr += " format(\"" + format + "\")";
              }

              return srcStr;
            }).join(', ');
          }
        }

        return changeCase_1.paramCase(key) + ": " + value + ";";
      }).join('\n	') + "\n}";
      fontFaceStore[fontFaceId] = true;
    }
  }

  return response;
}

exports.getFontFaceCss = getFontFaceCss;

function getFontFacesCss(fontFaces, baseUrl) {
  if (!isArrayLike_1.isArrayLike(fontFaces)) {
    return '';
  }

  var fontFaceStore = getFontFaceStore();
  var results = fontFaces.map(function (fontFace) {
    return getFontFaceCss(fontFace, baseUrl, fontFaceStore);
  }).filter(function (result) {
    return !!result;
  }).join('\n');
  return results;
}

exports.getFontFacesCss = getFontFacesCss;

function getFontFaceStore() {
  var FONT_FACE_STORE_KEY = '__ksysFontFaceStore__';

  if (!window[FONT_FACE_STORE_KEY]) {
    window[FONT_FACE_STORE_KEY] = {};
  }

  return window[FONT_FACE_STORE_KEY];
}

exports.getFontFaceStore = getFontFaceStore;